import { z } from 'zod';
const ConfigurationEntityType = z.enum([
    'COMPANY',
    'COMPANY_PROFILE',
    'USER_PROFILE',
    'USER',
    'UNIT',
    'DEFAULT',
]);
export const configurationDefinitionSchema = z.object({
    key: z.string(),
    name: z.string(),
    description: z.string(),
    inheritanceType: z.enum(['STRING', 'JSON_SET_STRING']),
    metaConfigDefaultValue: z.boolean(),
    customerInheritFromCompany: z.boolean(),
    serviceName: z.string(),
    validationSchema: z.custom(),
    defaultValue: z.unknown(),
    tags: z.array(z.string()),
    writeableOnEntityType: z.array(ConfigurationEntityType),
    readableOnEntityType: z.array(ConfigurationEntityType),
    migrated: z.boolean(),
});
